export default {
    AZURE_STORAGE_URL: "https://handsonbooking.blob.core.windows.net",
    RESIZED_IMG_PREFIX: "resized",
    CLIENT_PREFIX: "client",
    THERAPIST_PREFIX: "therapist-images-container",
};
